import React from 'react'
import cx from 'classnames'
import { useMemo } from 'sb-hooks'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import s from './ProductTag.scss'


const availableTagNames = [
  'addictive',
  'adventurous',
  'aquatic',
  'casual',
  'citrusy',
  'classic',
  'clean',
  'datenight',
  'elegant',
  'everyday',
  'fall',
  'feminine',
  'flirty',
  'floral',
  'fresh',
  'fruity',
  'girly',
  'hangingout',
  'light',
  'mysterious',
  'office',
  'party',
  'powdery',
  'sexy',
  'sophisticated',
  'spicy',
  'spring',
  'strong',
  'summer',
  'sweet',
  'trendsetter',
  'unique',
  'uplifting',
  'vacation',
  'warm',
  'winter',
  'woody',
  'workout',
]

type ProductTagProps = {
  className?: string
  tagClassName?: string
  name: string
  img?: string
  lightGray?: boolean
  withTitle?: boolean
}


const ProductTag: React.FunctionComponent<ProductTagProps> = (props) => {
  const { className, tagClassName, name, img, lightGray, withTitle } = props

  const tagStyle = useMemo(() => {
    if (img) {
      return { backgroundImage: `url(${img})` }
    }
  }, [ img ])

  const tagIconName = useMemo(() => {
    if (name) {
      const tagName = name.replace(/\s|-/g, '_').toLowerCase()

      if (availableTagNames.includes(tagName)) {
        return `tag_${tagName}`
      }

      console.warn(`There is no icon for tag with name "${name}"`)
      return null
    }
  }, [ name ])

  return (
    <div className={className} data-testid="productTag">
      <div
        className={cx(tagClassName, {
          [s.tagIcon]: img,
          [s.tagSpriteIcon]: !img,
          [s[tagIconName]]: tagIconName,
          [s.lightGray]: lightGray,
        })}
        style={tagStyle}
      />
      {
        withTitle && (
          <Box mt={8}>
            <Text
              message={name}
              size="14-16"
              align="center"
              dataTestId="productTagTitle"
            />
          </Box>
        )
      }
    </div>
  )
}


export default ProductTag
